import { EventEmitter, Injectable, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IHttpSuccessPayload } from '@core/models';
import { FpxModal, FpxModalAfterClosed, HttpProviderService, HttpRequest } from '@fpx/core';
import { HttpRequestPayload, IHttpErrorPayload } from '@fpx/core';
import { BehaviorSubject, catchError, map, Observable, of, Subject, takeUntil, throwError } from 'rxjs';
import { CBXDialogData, DialogService } from 'src/app/fpx-core/services/dialog/dialog.service';
import { environment } from 'src/environments/environment';
import { IProcessInfo, IProcessShellRouterInfo, IResultIconData } from '../models/process-shell.model';
import { UserService } from "../../user.service";
import { CommonService } from 'src/app/common.service';
import { PopupService } from 'src/app/common/services/popup/popup.service';
import { Data } from 'src/app/DataService';
import { TranslateService } from '@ngx-translate/core';
import { ErrorAlertComponent } from 'src/app/rcob/error-alert/error-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { SupplapplicantService } from 'src/app/rcob/supplapplicant-service/supplapplicant.service';
import { ApplicationstatusService } from 'src/app/rcob/applicationstatus-service/applicationstatus.service';
import { ApplicantService } from 'src/app/rcob/applicant-service/applicant.service';
import { AdaFormConfigService } from 'src/app/rcob/ada-form-service/ada-form-config.service';
import { AdaFormService } from 'src/app/rcob/ada-form-service/ada-form.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessShellService {

  formClassName: string = "";
  processTitle: string = "";
  processCompleted: string | number = 20;
  processCode: string = "";
  processId: string = "";
  stageCode: string = "";
  progressBarVisible: boolean = false;
  stepBarDetails = [];
  formComponent: any;
  isFormValid: boolean = false;
  popup: boolean = false;
  isFormSubmitted: boolean = false;
  isResultPage: boolean = false;
  closeNavigation: string[];
  backNavData: any[] = [];
  cobData: any = {};
  formType: '1' | '2' = '1';

  private _footerVisible: boolean = true;
  private _headerVisible: boolean = true;
  private _arnVisible: boolean = false;
  private _bodInfoVisible: boolean = true;
  private _shellRoutingParams: any;
  private _formValidStatus$: Subject<boolean> = new Subject<boolean>();
  private _formSubmittedCompleteStatus$: Subject<any> = new Subject<any>();

  isSentbackApplication: boolean = false;
  processInfo: IProcessInfo;
  updatedProcessInfo: boolean;
  userName: string;

  private draftProcess: any[] = [];
  private draftProcessInfo = {};
  submitBtnText: string = 'Proceed';
  resultIconData: IResultIconData[];
  resultIconClick: EventEmitter<any>;
  private _backBtnVisible: boolean = false;
  private _cancelBtnVisible: boolean = true;
  private _resetBtnVisible: boolean = true;
  private _commonHeaderVisible: boolean = true;
  private samePageRoutingModule: string[] = ['cc-flash', 'dc-flash'];
  private anotherPageRoutingModule: string[] = ['pfm-category'];

  arn: string = '';
  arnTitle: string = '';
  arnDescription: string = '';
  processList: any = [];
  private _progressBarVisible: boolean = false;
  activeStage: string = '';
  activeStageIndex: number = 0;

  protected _bodTitle: string = "";
  protected _bodInfoData: any;

  private _stageContext: any;
  public isStageContextAvailable: boolean = false;

  applicantStageInfo = {
    "stageCompletionPercentage": "20",
    "stageUIConfig": {
      "editAllowed": "1",
      "navigationPath": "rcob/applicant-info",
      "title": "Applicant Detils",
      "routingParam": "{\"action\":\"MODIFY\"}",
      "backwardReq": "1"
    },
    "stageCode": "ApplicantInfo",
    "groupCode": "2"
  };
  supplApplicantStageInfo = {
    "stageCompletionPercentage": "20",
    "stageUIConfig": {
      "editAllowed": "1",
      "navigationPath": "rcob/suppl-applicant",
      "title": "Applicant Detils",
      "routingParam": "{\"action\":\"MODIFY\"}",
      "backwardReq": "1"
    },
    "stageCode": "SupplApplicantInfo",
    "groupCode": "2"
  };
  primaryCardHolderStageInfo = {
    "stageCompletionPercentage": "45",
    "stageUIConfig": {
      "editAllowed": "1",
      "navigationPath": "rcob/suppl-prim-address",
      "title": "Primary Applicant Info",
      "routingParam": "{\"action\":\"MODIFY\"}",
      "backwardReq": "1"
    },
    "stageCode": "PrimaryApplicantInfo",
    "groupCode": "2"
  };
  pendencyStageInfo = {
    "stageCompletionPercentage": "30",
    "stageUIConfig": {
      "editAllowed": "1",
      "navigationPath": "rcob/pendency-details",
      "title": "Return Reasons",
      "routingParam": "{\"action\":\"MODIFY\"}",
      "backwardReq": "1"
    },
    "stageCode": "PendencyInfo",
    "groupCode": "2"
  };
  supplApplicantInfo: any;
  offerCode: any;
  excemptSegmentFlag: any;
  matchCount: any;
  incrementStage: number = 1;
  screenMode: string;
  rloCardDetails: any;
  @Output() additionaldocupload: EventEmitter<any> = new EventEmitter();
  applicationStatus: any;
  appRef: any;
  hiddenProcessCode: any;
  checkAppStatus: boolean;
  sourceRefNum: any;
  // secondaryProcessId: any;
  // secondaryProcessCode: any;
  ;


  constructor(
    private _http: HttpProviderService,
    private _router: Router,
    private _dialogService: DialogService,
    private _userService: UserService,
    private _commonService: CommonService,
    private _popupService: PopupService,
    private _dataStore: Data,
    private translate: TranslateService,
    private _dialog: MatDialog,
    private _suppApplicantService: SupplapplicantService,
    private _applicationstatusService: ApplicationstatusService,
    private _applicantService: ApplicantService,
    private _adaFormConfig: AdaFormConfigService,
    private _adaFormService: AdaFormService
  ) { }

  getCurrentStageCodeFromRoute(): string | undefined {
    const url = this._router.url;
    if (url.includes('Suppl-customer-dtls')) return 'SupplCustomerDetails';
    if (url.includes('suppl-occupation-info')) return 'SupplOccupationInfo';
    if (url.includes('suppl-document-info')) return 'documentinfo';
    if (url.includes('suppl-applicant')) return 'SupplApplicantInfo';
    
    if (url.includes('ApplicantInfo')) return 'ApplicantInfo';
    if (url.includes('CustomerDetails')) return 'CustomerDetails';
    if (url.includes('AddressDetails')) return 'AddressDetails';
    if (url.includes('OccupationDetails')) return 'OccupationDetails';
    if (url.includes('CardDetails')) return 'CardDetails';
    if (url.includes('documentinfo')) return 'documentinfo';
    if (url.includes('AdaForm')) return 'AdaForm';
    return undefined;
  }

  initializeProcessShell() {
    if (this._shellRoutingParams) {
      if (this._shellRoutingParams.processCode) this.processCode = this._shellRoutingParams.processCode;
      if (this._shellRoutingParams.processTitle) this.processTitle = this._shellRoutingParams.processTitle;
      this.formType = this._shellRoutingParams.formType || '1';
    }
    this.setSaveRequest(false);


    if (this.formType == '1') {
      this.formClassName = "onboarding-form";
      this.closeNavigation = ['onboarding'];
      this.popup = true;
      this.prepareProcess();
    } else {
      this.formClassName = "";
      this.popup = false;
    }

    this._formValidStatus$ = new Subject<boolean>();
    this.getFormValidStatus().subscribe((res) => {
      this.isFormValid = res;
    });

    this._formSubmittedCompleteStatus$ = new Subject<any>();

    this.getFormSubmittedCompleStatus().subscribe((res) => {
      if (!this.stageCode) {
        this.stageCode = this.getCurrentStageCodeFromRoute();
      }
      const showAdaForm = this._adaFormConfig.payrollIdentifier === 1 || this._adaFormConfig.payrollIdentifier === '1';

      if (this.stageCode === 'AdaForm') {
        if (res?.processId) this.setProcessId(res.processId);
        const routingParams = { processId: this.processId, processCode: this.processCode };
        this.navigateTo(['process-shell', 'rcob', 'result-info'], routingParams);
        return;
      }

      let currentStageIndex = this.processInfo?.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode });
      let stageInfo;
      if (currentStageIndex >= 0) stageInfo = this.processInfo?.stageInfo[currentStageIndex + this.incrementStage];

      if (showAdaForm && this.stageCode === 'documentinfo' && !stageInfo) {
        this.activeStageIndex = this.processList.findIndex(item => item.stageCode === 'AdaForm');
        if (this.activeStageIndex >= 0) {
          const docStageInfo = this.processInfo.stageInfo.find((s: any) => s.stageCode === 'documentinfo');
          if (docStageInfo) {
            const docRoutingParams = docStageInfo.stageUIConfig.routingParam
              ? (typeof docStageInfo.stageUIConfig.routingParam === 'string' ? JSON.parse(docStageInfo.stageUIConfig.routingParam) : docStageInfo.stageUIConfig.routingParam)
              : {};
            docRoutingParams['action'] = 'MODIFY';
            docRoutingParams['viaProcessInfo'] = true;
            docRoutingParams['processId'] = this.processId;
            docRoutingParams['processCode'] = this.processCode;
            docRoutingParams['currentStage'] = 'documentinfo';
            docRoutingParams['response'] = this.processInfo.processPayload?.[this.processCode]?.['documentinfo'];
            const docPath = (docStageInfo.stageUIConfig.navigationPath || '').split('/').filter(Boolean);
            const docRouterPath = ['process-shell'].concat(docPath);
            if (this.formType == '1') docRouterPath.unshift('onboarding');
            this.pushBackNav({ backNavpath: docRouterPath.slice(), queryParams: docRoutingParams });
          }
          this.setTitle('ADA Form');
          this.processCompleted = this.activeStageIndex < this.processList.length ? String((this.activeStageIndex + 1) * 100 / this.processList.length) : '100';
          this._adaFormService.findByKey({ appRef: this.processId })().subscribe({
            next: (data) => {
              const hasData = data && (typeof data !== 'object' || Object.keys(data).length > 0);
              this.stageCode = 'AdaForm';
              this.incrementStage = 1;
              const routingParams: any = {
                action: hasData ? 'MODIFY' : 'ADD',
                viaProcessInfo: true,
                processId: this.processId,
                processCode: this.processCode,
                currentStage: 'AdaForm',
                response: hasData ? data : null
              };
              this.navigateTo(['process-shell', 'rcob', 'ada-form'], routingParams);
            },
            error: () => {
              if (res?.processId) this.setProcessId(res.processId);
              this.fetchProcessInstance(res);
            }
          });
          return;
        }
      }

      if (this.processInfo && stageInfo) {
        this.activeStageIndex = currentStageIndex + this.incrementStage;
        // stageInfo = this.processInfo.stageInfo[this.processInfo.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode }) + 1];
        let routingParams = stageInfo.stageUIConfig.routingParam ? ((typeof (stageInfo.stageUIConfig.routingParam) === 'string') ? JSON.parse(stageInfo.stageUIConfig.routingParam) : stageInfo.stageUIConfig.routingParam) : {};
        this.setTitle(stageInfo.stageUIConfig.title);
        this.processCompleted = stageInfo.stageCompletionPercentage;
        let path = (stageInfo.stageUIConfig.navigationPath) ? stageInfo.stageUIConfig.navigationPath.split('/') : '';
        let routerPath = ['process-shell'].concat(path);

        routingParams['action'] = 'MODIFY';
        routingParams['viaProcessInfo'] = true;
        routingParams['processId'] = this.processId;
        routingParams['currentStage'] = this.stageCode = stageInfo.stageCode;
        // let processCode = this.secondaryProcessCode?this.secondaryProcessCode: this.processCode;

        routingParams['processCode'] = this.processCode;
        routingParams['response'] = this.processInfo.processPayload?.[this.processCode]?.[stageInfo.stageCode];
        this.incrementStage = 1; 
        this.navigateTo(routerPath, routingParams)

      }
      else {
        if (res?.processId) this.setProcessId(res.processId);
        this.fetchProcessInstance(res);
      }
    });

  }

  navigateTo(routerPath, routingParams) {
    // Desktop post login
    let currentRoutePath = this._router.url.split('/');
    let nextRoute = routerPath;

    window.scrollTo(0,0);

    if (this.formType != '1' && this._commonService.isDesktop()) {

      if (!nextRoute) {
        this._dialogService.open({
          component: 'result',
          data: routingParams,
          panelClass: 'result-page-dialog'
        });
        return;
      }
      this._router.navigate(nextRoute, {
        queryParams: routingParams,
        queryParamsHandling: 'preserve'
      });
      return;
    }

    if (this.formType == '1') {
      routerPath.unshift('onboarding');
      let onboardingContainer = document.querySelector('.onboarding-container');
      onboardingContainer?.scrollTo(0, 0);
    }

    this._router.navigate(nextRoute ? nextRoute : routerPath, {
      queryParams: routingParams,
      queryParamsHandling: 'preserve'
    });

  }

  onAfterFormInit(formCtrl: any) {
    this.formComponent = formCtrl;

    this.formComponent._helper.doAfterPostInit = () => {
      if (this._stageContext) {
        if (this.stageCode == "documentinfo" && this.applicationStatus?.status == "AddlDocmt") {
          let _docHelper = this.formComponent._helper;
          if (_docHelper.docdtls?.value?.length < _docHelper.docGrpDtls?.docdtls?.length) {
            _docHelper.docGrpDtls.docdtls.forEach(element => {
              let index = _docHelper.docdtls.value.findIndex(x => x.documentType == element.documentType);
              if (index == -1) {
                _docHelper.docdtls.value.push(element);
              }
            });
          }
          // else this.formComponent.formGroup.patchValue(this._stageContext, {emitEvent:false});
        }
        else this.formComponent.formGroup.patchValue(this._stageContext, { emitEvent: false });
      }
      if (this.formComponent._helper.getRoutingParam('viaProcessInfo') && this.applicationStatus?.status != "AddlDocmt") {
        this.setSaveRequest(false);
      }
      if (this.applicationStatus?.status == "AddlDocmt") {
        this.setResetBtnAvailable(false);
      }
    }

    this.resetShellLayout();
    let shellRouterData = this._router.getCurrentNavigation()?.extras?.queryParams;
    this.setShellRoutingParams(shellRouterData);
    this.updateShell();
    if (shellRouterData?.additionalDetails?.backNavData) {
      this.pushBackNav(shellRouterData?.additionalDetails?.backNavData)
    }

    if (this.formComponent.formGroup) {
      if (this.formType == '1') {
        this.formComponent.addFormControl('appRef', this.processId,[]);
      }
      this.formComponent.formGroup.valueChanges.subscribe((value) => {
        this.triggerFormValidStatus(this.formComponent.formGroup.valid || this.formComponent.formGroup.disabled);
      });
    }
  }

  fetchProcessInstance(response: any) {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/processinstance/{processCode}/{processId}');
    httpRequest.addPathParameter('processCode', this.processCode);
    httpRequest.addPathParameter('processId', this.processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.commonPublisher);

    this._stageContext = null;
    return this._http.invokeRestApi(httpRequest).subscribe(
      {
        next: (routerInfo: any) => {
          this.draftProcess.push({
            queryParams: this.getShellRoutingParams()
          });

          let processInstance: IProcessShellRouterInfo = routerInfo?.body.processinstance;

          if (processInstance?.currentStage === 'ADAformdetails') {
            processInstance.currentStage = 'AdaForm';
          }

          this.activeStageIndex = this.processList.findIndex(item => item.stageCode == processInstance.currentStage);

          if (Object.keys(processInstance).length === 0 && this.formType == '1') {
            this.onApiError();
            return;
          }

          let params = (typeof (processInstance.routingParam) === 'string') ? JSON.parse(processInstance.routingParam) : processInstance.routingParam;

          if(this.formType == '1' && response && params && params.stageCode) {
            this.draftProcessInfo[params.stageCode] = response;
          }

          if (params?.formType) {
            this.setFormType(params.formType);
          }
          this.setTitle(processInstance.title);
          this.processCompleted = processInstance.completionPercentage;


          if(processInstance?.contextData){
            this._stageContext = JSON.parse(processInstance?.contextData);
            this.isStageContextAvailable = true;
            if (
              processInstance.currentStage === "documentinfo" &&
              this._stageContext?.docdtls?.length
            ) {
              this._stageContext = this.flattenContextDataDocumentinfo(this._stageContext);
            }
          } else {
            this._stageContext = null;
            this.isStageContextAvailable = false;
          }

          let routingParams = {
            ...params,
            response: response || null,
            stageContext: this._stageContext
          }
          routingParams['stageContext'] = this._stageContext;
          if(this.processCode)routingParams['processCode'] = this.processCode;

          if (processInstance.currentStage == "FailureEnd") {
            this.handleFailureScanario(params);
            return
          }
          if (processInstance.currentStage == 'SuccessEnd') {
            routingParams['processId'] = this.processId;
            routingParams['currentStage'] = processInstance.currentStage;
            if (processInstance.navigationPath) {
              let backNavPath = processInstance.navigationPath.split('/')
              routingParams['backNavPath'] = backNavPath[0];
            }
            this.stageCode = processInstance.currentStage;
          }
          else this.stageCode = processInstance.currentStage;
          this.backNavData = [];
          if (routingParams?.openAsPopup == '1') {
            let panelClass = ['verify-otp-modal', 'info-modal'];
            let _component = this._popupService.getComponent(processInstance.navigationPath);
            let modal = new FpxModal();
            modal.setAutoFocus(true);
            modal.setBackDropClass('backdrop');
            modal.setWidth('');
            modal.setHeight('');
            modal.setPanelClass(panelClass);
            modal.setComponent(_component);
            modal.setData({
              routingParams: routingParams
            });
            modal.setId('verifyOTPModal');
            modal.setAfterClosed(this._modelAfterClose);
            this._popupService.openModal(modal);
          } else {
            let path = (processInstance.navigationPath) ? processInstance.navigationPath.split('/') : '';
            let routerPath = ['process-shell'].concat(path);

            if (routingParams.currentStage == 'SuccessEnd' && routingParams.navigationPath == "rcob/view-application-status") {
              this.fetchApplicationStatus(routerPath, routingParams);
              this._commonService.hideSpinner();
              return;
            }

            if (this.updatedProcessInfo && this.processInfo) {
              let activeStageIndex = this.processInfo.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode });
              let stageInfo = this.processInfo.stageInfo[activeStageIndex];
              if (!stageInfo) {
                this.navigateTo(routerPath, routingParams);
              }
              else {
                this.activeStageIndex = activeStageIndex;
                this.incrementStage = 0;
                this._formSubmittedCompleteStatus$.next(true);
              }
            }
            else {
              this.navigateTo(routerPath, routingParams);
            }
            this._commonService.hideSpinner();
          }
        },
        error: () => { },
        complete: () => { }
      }
    );
  }
  fetchApplicationStatus(routerPath?, routingParams?) {
    this._applicationstatusService.getApplicationStatus(this.processId).subscribe({
      next: (res) => {
        if (res) {
          this.applicationStatus = res.applicationstatus;
          this.processId = res.applicationstatus.appRef;
          this.processCode = res.applicationstatus.processCode;
          if (routerPath && routingParams) {
            this.getRequiredDetails(() => {
              this.navigateTo(routerPath, routingParams);
            })
          }
        }
      }
    });
  }
  handleFailureScanario(params) {
    let _data: CBXDialogData = {
      title: 'Failed',
      message: params.message?params.message: 'Please try again later',
    }

    const dialogRef = this._dialog.open(ErrorAlertComponent, {
      data: _data,
      panelClass: ['error-alert-dialog'],
      backdropClass: 'confirmation-dialog-backdrop',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(action => {
      if (this._commonService.getApplicationMode() == 'RM') this._router.navigate(['rm-home']);
      else this._commonService.exitApplication();
    });
  }

  setShellRoutingParams(params: any) {
    try {
      if (this.formComponent) this.formComponent.setRoutingParam(params);
    } catch (reason) {

    }

    this._shellRoutingParams = params;

    if (this.formType == '1') {
      this.formClassName = "onboarding-form";
      this.closeNavigation = ['login'];
      this.popup = true;
      this.setProcessBarVisible(true);
    } else {
      this.setProcessBarVisible(false);
    }
  }
  getShellRoutingParams(): any {
    return this._shellRoutingParams;
  }
  clearShellRoutingParams() {
    this._shellRoutingParams = null;
  }

  /**
   * Process shell footer visible getter, setter
   * @param visible
   */
  setFooterVisible(visible:boolean = true) {
    this._footerVisible = visible;
  }
  getFooterVisible():boolean {
    return this._footerVisible;
  }

  setHeaderVisible(visible:boolean = true) {
    this._headerVisible = visible;
  }
  getHeaderVisible():boolean {
    return this._headerVisible;
  }

  /**
   * Defer toggling so nested routes (e.g. application status → view tabs) do not update this flag
   * in the same change-detection pass as `process-shell`’s `*ngIf="getARNVisible()"` (NG0100).
   */
  setARNVisible(visible: boolean = true) {
    queueMicrotask(() => {
      this._arnVisible = visible;
    });
  }
  getARNVisible(): boolean {
    return this._arnVisible;
  }

  setProcessBarVisible(visible: boolean) {
    this._progressBarVisible = visible;
  }
  getProcessBarVisible(): boolean {
    return this._progressBarVisible;
  }

  setBackbtnVisible(visible: boolean = true) {
    this._backBtnVisible = visible;
  }

  isBackBtnAvailable(): boolean {
    return this._backBtnVisible;
  }
  isCancelBtnAvailable(): boolean {
    return this._cancelBtnVisible;
  }

  setCancelBtnAvailable(visible: boolean = true) {
    this._cancelBtnVisible = visible;
  }
  isResetBtnAvailable(): boolean {
    return this._resetBtnVisible;
  }
  setResetBtnAvailable(visible: boolean = true) {
    this._resetBtnVisible = visible;
  }
  isCommonHeaderVisible(): boolean {
    return this._commonHeaderVisible;
  }
  setCommonHeaderVisible(visible: boolean = true) {
    this._commonHeaderVisible = visible;
  }
  setBODInfoVisible(visible: boolean) {
    this._bodInfoVisible = visible;
  }

  getBODInfoVisible(): boolean {
    return this._bodInfoVisible;
  }

  setTitle(title: string) {
    this.processTitle = title;
  }

  setProcessCode(processCode: string) {
    this.processCode = processCode;
  }

  setProcessId(processId: string) {
    this.processId = processId;
  }
  getProcessId(): string {
    return this.processId;
  }

  setFormType(formType: '1' | '2') {
    this.formType = formType;
  }

  getFormType() {
    return this.formType;
  }

  triggerFormValidStatus(val) {
    this._formValidStatus$.next(val);
  }
  getFormValidStatus(): Observable<boolean> {
    return this._formValidStatus$;
  }

  triggerFormSubmittedCompleteStatus(val) {
    // dynamically set payrollIdentifier from the payload (or payload.data)
    let identifier = undefined;
    if (val && val.payrollIdentifier !== undefined) {
      identifier = val.payrollIdentifier;
      // val.payrollIdentifier
    } else if (val && val.data && val.data.payrollIdentifier !== undefined) {
      identifier = val.data.payrollIdentifier;
      // val.data.payrollIdentifier
    }

    if (identifier !== undefined) {
      this._adaFormConfig.payrollIdentifier = identifier;
      this._adaFormConfig.payrollAccountNumber = val?.data?.payrollAccountNumber ?? val?.payrollAccountNumber ?? '';
      // Re-trigger the prepareProcess to rebuild the this.processList array
      this.prepareProcess();
    }

    if (val?.error) {
      let message = (val?.error?.error?.ErrorDescription) ? val?.error?.error?.ErrorDescription : "Some Thing Went Wrong!";
      let baseRouteArray = this._router?.url?.split('/');
      let baseRoute = baseRouteArray[baseRouteArray?.length - 2]
      let routingParams = { backNavPath: baseRoute ? baseRoute : '', currentStage: "FailureEnd", message: message }
      setTimeout(() => {
        this.navigateTo(['process-shell', baseRoute ? baseRoute : '', 'result-info'], routingParams);
      }, 200);
    } else {
      if ((this.updatedProcessInfo && this.processInfo) || !sessionStorage.getItem('access_token') || !this.processCode || !this.processId) {
        this._formSubmittedCompleteStatus$.next(val);
      }
      else {
        this.getRequiredDetails(() => {
          this.getProcessInfo('forward', val);
        })
      }

    }
  }
  getFormSubmittedCompleStatus(): Observable<any> {
    return this._formSubmittedCompleteStatus$;
  }

  redirectTo(path: string[], queryParams: any = {}) {
    this._router.navigate(path, {
      queryParams: queryParams,
      queryParamsHandling: 'preserve'
    });
  }

  onApiError() {
    let CBXDialogData = {
      result: 'failure',
      icon: 'cob-failure-alert',
      title: 'Service Temporarily Unavailable.',
      message: "Sorry we couldn't able to fetch data from your document at this time",
      okLabel: 'Close',
    }
    this._dialogService.open({
      component: 'alert',
      data: CBXDialogData,
      closeFn: (res) => this.onCloseDialog(res)
    })
  }
  onCloseProcess() {
    // if (!this._userService.getToken()) { this._router.navigate(['welcome']); return; }
    let CBXDialogData = {
      icon: 'Exit-application',
      result: 'success',
      title: 'Resume Later',
      refNum: this.processId,
      message: 'Do you want to close the window and resume your application later?',
      okLabel: 'Yes',
      cancelLabel: 'No'
    }
    this._dialogService.open({
      component: 'confirmation',
      data: CBXDialogData,
      panelClass: ['confirmation-dialog', 'confirmation-modal'],
      closeFn: (res) => this.onCloseDialog(res)
    })
  }
  onCloseDialog(res): any {
    if (res == 1) {
      if (this._commonService.getApplicationMode() != 'RM') {
        this.popup = false;
        this.updatedProcessInfo = false;
        this.processInfo = this.stageCode = undefined;
        sessionStorage.removeItem('userId');
        this._userService.removeToken();
        this._router.navigate(this.closeNavigation);
        this.clearDraftProcessInfo();
        this.onCancel();
      }
      else
        this._router.navigate(['rm-home']);
    }
  }

  clearShell() {
    this.popup = false;
    this.updatedProcessInfo = false;
    this.processInfo = this.stageCode = undefined;
    this._saveRequest = false;
    this.applicationStatus = undefined;
    this.appRef = this.screenMode = undefined;
    this.clearDraftProcessInfo();
    this.offerCode = this.matchCount = this.excemptSegmentFlag = undefined;
    this.rloCardDetails = '';
    this.submitBtnText = 'Proceed';
  }
  fetchProcessInfo(): Observable<IProcessInfo> {
    this._commonService.showSpinner();
    if (this.processInfo && this.updatedProcessInfo) {
      this._commonService.hideSpinner();
      return of(this.processInfo);
    }
    const httpRequest = new HttpRequest();
    let processId = this.appRef ? this.appRef : this.processId;
    let processCode = this.hiddenProcessCode ? this.hiddenProcessCode : this.processCode;
    httpRequest.setResource('/processinfo/{processCode}/{processId}');
    httpRequest.addPathParameter('processCode', processCode);
    httpRequest.addPathParameter('processId', processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.customersPublisher);

    return this._http.invokeRestApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
      if (response?.body?.processInfo?.processPayload[processCode]?.documentinfo) {
        let docdtls = response?.body?.processInfo?.processPayload[processCode]?.documentinfo.docdtls;
        if (docdtls) {
          let documentinfo = []
          for (var i = 0; i < docdtls.length; i++) {
            const prnt = docdtls[i].prntDocType || docdtls[i].documentType;
            for (var j = 0; j < docdtls[i].documents?.length; j++) {
              documentinfo.push({ prntDocType: prnt, ...docdtls[i]?.documents[j] });
            }
          }
          if (documentinfo.length) {
            docdtls = documentinfo;
            response.body.processInfo.processPayload[processCode].documentinfo.docdtls = documentinfo;
          }
          docdtls.map((doctype) => {
            if (Array.isArray(doctype.documentfileinv)) {
              doctype.documentfileinv.forEach((file) => {
                file.invNumber = file.docInvNum;
              })
              let docfileinv = [{ "docInvNum": doctype.documentfileinv }];

              delete doctype.documentfileinv;
              doctype.documentfileinv = docfileinv;
            }
          })
        }
      }
      if (processCode == 'CARDORG') {
        if (response?.body?.processInfo?.processPayload[processCode]?.CustomerDetails) {
          response.body.processInfo.processPayload[processCode]['ApplicantInfo'] = response?.body.processInfo.processPayload[processCode]?.CustomerDetails;
          if (this.getApplicationMode() == 'RM') {
            this.applicantStageInfo.stageUIConfig.navigationPath = 'rcob/rm-applicant-info';
          }
          if (this.applicationStatus?.status == 'DDE' && this.isSentbackApplication) {
            response.body.processInfo.processPayload[processCode]['PendencyInfo'] = '';
            response.body.processInfo.stageInfo.unshift(this.pendencyStageInfo);
          }
          response.body.processInfo.stageInfo.unshift(this.applicantStageInfo);
        }
        else if (response?.body == null) {
          response.body = {};
          response.body.processInfo = {};
          response.body.processInfo.processPayload = {};
          response.body.processInfo.processPayload[processCode] = {};
          response.body.processInfo.processPayload[processCode]['ApplicantInfo'] = this.draftProcessInfo['ApplicantInfo'];
          response.body['processInfo']['stageInfo'] = [];
          if (this.getApplicationMode() == 'RM') {
            this.applicantStageInfo.stageUIConfig.navigationPath = 'rcob/rm-applicant-info';
          }
          response.body['processInfo']['stageInfo'].unshift(this.applicantStageInfo);
        }
        if (response.body.processInfo?.stageInfo) {
          response.body.processInfo.stageInfo = response.body.processInfo.stageInfo.filter(
            (stage: any, index: number, self: any[]) => self.findIndex(s => s.stageCode === stage.stageCode) === index
          );
        }
        this.updatedProcessInfo = true;
        this.processInfo = response?.body.processInfo;
        this._commonService.hideSpinner();
        return this.processInfo;
      }
      else if (processCode == 'SUPPLCARDORG') {
        if (response?.body == null) {
          response.body = {};
          response.body.processInfo = {};
          response.body.processInfo.processPayload = {};
          response.body.processInfo.processPayload[processCode] = {};
          response.body['processInfo']['stageInfo'] = [];
        }
        if (response.body.processInfo) {
          if (!response.body.processInfo.processPayload) {
            response.body.processInfo.processPayload = {};
          }
          if (!response.body.processInfo.processPayload[processCode]) {
            response.body.processInfo.processPayload[processCode] = {};
          }
          if (!response.body.processInfo.stageInfo) {
            response.body.processInfo.stageInfo = [];
          }
        }
        response.body.processInfo.processPayload[processCode]['SupplApplicantInfo'] = this.supplApplicantInfo;
        if (this.getApplicationMode() == 'RM') {
          let isPrimaryApplicantStageAvailable = response.body.processInfo.stageInfo.filter((sinfo) => sinfo.stageCode == "PrimaryApplicantInfo").length > 0;
          if (!isPrimaryApplicantStageAvailable) {
            response.body.processInfo.processPayload[processCode]['PrimaryApplicantInfo'] = '';
            response.body.processInfo.stageInfo.unshift(this.primaryCardHolderStageInfo);
          }
        }
        if (this.applicationStatus?.status == 'DDE' && this.isSentbackApplication) {
          response.body.processInfo.processPayload[processCode]['PendencyInfo'] = '';
          response.body.processInfo.stageInfo.unshift(this.pendencyStageInfo);
        }
        response.body.processInfo.stageInfo.unshift(this.supplApplicantStageInfo);
        if (response.body.processInfo?.stageInfo) {
          response.body.processInfo.stageInfo = response.body.processInfo.stageInfo.filter(
            (stage: any, index: number, self: any[]) => self.findIndex(s => s.stageCode === stage.stageCode) === index
          );
        }
        this.updatedProcessInfo = true;
        this.processInfo = response?.body.processInfo;
        this._commonService.hideSpinner();
        return this.processInfo;
      }
      this._commonService.hideSpinner();
    },
      catchError((err: IHttpErrorPayload) => {
        console.error("Error in fetchProcessInfo invokeRestApi:", err);
        this._commonService.hideSpinner();
        return throwError(err)
      })));
  }

  fetchAdditionaldocupload(): Observable<any> {
    const httpRequest = new HttpRequest();
    let processId = this.appRef ? this.appRef : this.processId;
    httpRequest.setResource('/additionaldocupload/{processId}');
    httpRequest.addPathParameter('processId', processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.customersPublisher);

    return this._http.invokeRestApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
      return response;
    },
      catchError((err: IHttpErrorPayload) => {
        return throwError(err)
      })));
  }

  getRequiredDetails(callback) {
    if (this.processCode == 'SUPPLCARDORG' && !this.supplApplicantInfo) {
      this._suppApplicantService?.findByKey({
        appRef: this.processId
      })().subscribe({
        next: (res: any) => {
          this.supplApplicantInfo = res;
          callback();
        },
        error: () => { this._commonService.hideSpinner(); },
        complete: () => { },
      });
    }
    else if (this.processCode == 'CARDORG' && (this.processInfo?.processPayload?.[this.processCode]?.CustomerDetails || !this.draftProcessInfo?.['ApplicantInfo'])) {
      this._applicantService?.findByKey({
        appRef: this.processId
      })().subscribe({
        next: (res: any) => {
          this.draftProcessInfo['ApplicantInfo'] = res;
          callback();
        },
        error: () => { this._commonService.hideSpinner(); },
        complete: () => { },
      });
    }
    else callback();
  }

  handleBackNavigation() {
    this._commonService.showSpinner();
    if (!this._userService.getToken()) { console.log('edit not allowed for the previous screen'); return; }

    if (this.stageCode === 'AdaForm' || this.stageCode === 'ADAformdetails') {
      const nav = this.popBackNav();
      if (nav?.backNavpath) {
        this.activeStageIndex = this.processList.findIndex((item: any) => item.stageCode === 'documentinfo');
        this.stageCode = 'documentinfo';
        const path = nav.backNavpath.slice();
        if (this.formType == '1' && path[0] !== 'onboarding') path.unshift('onboarding');
        this._router.navigate(path, { queryParams: nav.queryParams, queryParamsHandling: 'preserve' });
        this._commonService.hideSpinner();
        return;
      }
      if (this.processInfo) {
        const docStage = this.processInfo.stageInfo?.find((s: any) => s.stageCode === 'documentinfo');
        if (docStage) {
          this.activeStageIndex = this.processList.findIndex((item: any) => item.stageCode === 'documentinfo');
          this.stageCode = 'documentinfo';
          const docPath = (docStage.stageUIConfig.navigationPath || '').split('/').filter(Boolean);
          let routerPath = ['process-shell'].concat(docPath);
          const routingParams: any = docStage.stageUIConfig.routingParam ? (typeof docStage.stageUIConfig.routingParam === 'string' ? JSON.parse(docStage.stageUIConfig.routingParam) : docStage.stageUIConfig.routingParam) : {};
          routingParams['action'] = 'MODIFY';
          routingParams['viaProcessInfo'] = true;
          routingParams['processId'] = this.processId;
          routingParams['processCode'] = this.processCode;
          routingParams['currentStage'] = 'documentinfo';
          routingParams['response'] = this.processInfo.processPayload?.[this.processCode]?.['documentinfo'];
          this.navigateTo(routerPath, routingParams);
        }
        this._commonService.hideSpinner();
        return;
      }
    }

    if (this.getApplicationMode() == 'RM' && (this.getBodNumber() == 1)) {
      if (this.activeStageIndex == 1) {
        this.activeStageIndex = 0;
      }
      else if (this.activeStageIndex == 0) {
        this._router.navigate(['default-shell', 'rm', 'product-selection'])
      }
      this._commonService.hideSpinner();
    }
    else if (this.getApplicationMode() == 'RM' && this.activeStageIndex == 0 && this.screenMode == 'rm-view-mode') {
      this._router.navigate(['rm-home']);
    }
    else if (this.updatedProcessInfo) {
      this.setBackNavDetails(this.processInfo); return
    }
    else {
      this.getRequiredDetails(() => {
        this.getProcessInfo();
      })
    }

  }
  getProcessInfo(direction?, val?) {
    this.fetchProcessInfo().subscribe(
      {
        next: (res) => {
          if (direction == 'forward') this._formSubmittedCompleteStatus$.next(val);
          else this.setBackNavDetails(res);
        },
        error: (error) => {
          console.error("Error in getProcessInfo fetchProcessInfo subscription:", error);
          this._commonService.hideSpinner();
        }
      });
  }

  setBackNavDetails(processInfo: IProcessInfo) {
    this.activeStageIndex = processInfo.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode }) - 1;
    let stageInfo = processInfo.stageInfo[this.activeStageIndex];
    if (!stageInfo) {
      this.activeStageIndex = processInfo.stageInfo.length - 1;
      stageInfo = processInfo.stageInfo[processInfo.stageInfo.length - 1];
    }

    if (stageInfo.stageUIConfig.editAllowed != '1') {
      console.log('edit not allowed for the previous screen');
      return;
    }
    let routingParams = stageInfo.stageUIConfig.routingParam ? ((typeof (stageInfo.stageUIConfig.routingParam) === 'string') ? JSON.parse(stageInfo.stageUIConfig.routingParam) : stageInfo.stageUIConfig.routingParam) : {};

    this.setTitle(stageInfo.stageUIConfig.title);
    this.processCompleted = stageInfo.stageCompletionPercentage;
    let path = (stageInfo.stageUIConfig.navigationPath) ? stageInfo.stageUIConfig.navigationPath.split('/') : '';
    let routerPath = ['process-shell'].concat(path);

    routingParams['action'] = 'MODIFY';
    if (this.formComponent?._helper?.getRoutingParam('viaProcessInfo')) routingParams['viaProcessInfo'] = true;
    routingParams['processId'] = this.processId;
    routingParams['currentStage'] = this.stageCode = stageInfo.stageCode;
    // let processCode = this.secondaryProcessCode?this.secondaryProcessCode: this.processCode;
    routingParams['response'] = processInfo.processPayload?.[this.processCode]?.[stageInfo.stageCode];
    // if(this.activeStageIndex == 0) {
    //   routingParams['back'] = 1;
    // }
    this.navigateTo(routerPath, routingParams);
    this._commonService.hideSpinner();
  }

  pushBackNav(navDetails) {
    this.backNavData.push(navDetails)
  }
  popBackNav(): any {
    return this.backNavData.pop();
  }

  getInitialProcess() {
    return this.draftProcess[0];
  }
  clearDraftProcess() {
    this.draftProcess = [];
  }


  getDraftProcessInfo() {
    return this.draftProcessInfo;
  }
  setDraftProcessInfo(key, value) {
    this.draftProcessInfo[key] = value;
  }
  clearDraftProcessInfo() {
    this.draftProcessInfo = [];
  }

  updateShell() {
    if (this._shellRoutingParams && this._shellRoutingParams.processTitle) {
      this.processCode = this._shellRoutingParams.processCode;
      this.processTitle = this._shellRoutingParams.processTitle;
      this.formType = this._shellRoutingParams.formType || '1';

      if (this._commonService.isDesktop()) {
        this._commonService.isbackBtn = true;
        this._commonService.searchRequired = true;
        this._commonService.serviceDescription = this.processTitle;
      }
    }
  }

  private _modelAfterClose = (payload: any) => {
    // FpxModalAfterClosed
    console.log('form pop up action triggered in After Close event', payload);

    // dynamically set payrollIdentifier from the payload (or payload.data)
    let identifier = undefined;
    if (payload && payload.payrollIdentifier !== undefined) {
      identifier = payload.payrollIdentifier;
    } else if (payload && payload.data && payload.data.payrollIdentifier !== undefined) {
      identifier = payload.data.payrollIdentifier;
    }

    if (identifier !== undefined) {
      this._adaFormConfig.payrollIdentifier = identifier;
      // Re-trigger the prepareProcess to rebuild the this.processList array
      this.prepareProcess();
    }

    if (payload && payload['result'] != 'error') this.triggerFormSubmittedCompleteStatus(payload);
  }

  resetShellLayout() {
    this.isFormSubmitted = false;
    this._footerVisible = true;
    this._headerVisible = true;
    this._arnVisible = false;
  }

  getAdditionaldocupload() {
    this.fetchAdditionaldocupload().subscribe(
      {
        next: (res) => {
          this.offerCode = res.body.offerCode;
          this.excemptSegmentFlag = res.body.excemptSegmentFlag;
          this.matchCount = res.body.matchCount;
          this.additionaldocupload.emit();
        },
        error: (error) => {
          this._commonService.hideSpinner();
        }
      });
  }

  prepareARN(response: any) {
    if (response?.firstName && response?.OB_REF) {
      this.prepareProcess();
      let user = response?.firstName;
      user = user.substring(0, 1)+user.substring(1,user.length).toLowerCase();
      this.arnTitle = "Hi " + user + ", you're only a few steps away";
      if (this.processCode == 'CARDORG') {
        this.arnDescription = "Please make a note of the Reference Number provided for you Credit Card Application.<br/>You can use this Reference Number to check the status of your submitted/saved application";
      } else {
        this.arnDescription = "Please make a note of the Reference Number provided for your Supplementary Credit Card Application.<br/>You can use this Reference Number to check the status of your submitted/saved application.";
      }
      this.setSaveRequest(true);
      this.arn = response?.OB_REF;
    }
    this.getAdditionaldocupload();
  }

  private _saveRequest: boolean = false;
  setSaveRequest(request: boolean) {
    this._saveRequest = request;
  }
  getSaveRequest(): boolean {
    return this._saveRequest;
  }

  getProcessList() {
    return this.processList;
  }

  prepareProcess() {
    if (this.processCode == 'CARDORG') {
      if (this.getBodNumber() == 1 && this.getApplicationMode() == 'RM') {
        this.processList = [
          {
            'stageCode': 'ApplicationDetails',
            'stageName': 'Application details',
            'stageDescription': ''
          },
          {
            'stageCode': 'ApplicationDetails',
            'stageName': 'Application details',
            'stageDescription': ''
          },
          {
            'stageCode': 'CustomerDetails',
            'stageName': 'Customer details',
            'stageDescription': ''
          },
        ];
      }
      else {
        this.setSaveRequest(true);
        this.processList = [
          {
            'processCode': 'CARDORG',
            'stageCode': 'ApplicantInfo',
            'stageName': 'Applicant Details',
            'stageDescription': ''
          },
          {
            'processCode': 'CARDORG',
            'stageCode': 'CustomerDetails',
            'stageName': 'Customer Details',
            'stageDescription': ''
          },
          {
            'processCode': 'CARDORG',
            'stageCode': 'AddressDetails',
            'stageName': 'Address Details',
            'stageDescription': ''
          },
          {
            'processCode': 'CARDORG',
            'stageCode': 'OccupationDetails',
            'stageName': 'Employment Details',
            'stageDescription': ''
          },
          {
            'processCode': 'CARDORG',
            'stageCode': 'CardDetails',
            'stageName': 'Card Details',
            'stageDescription': ''
          },
          {
            'processCode': 'CARDORG',
            'stageCode': 'documentinfo',
            'stageName': 'Document Upload',
            'stageDescription': ''
          }
        ];
        if (this._adaFormConfig.payrollIdentifier === 1 || this._adaFormConfig.payrollIdentifier === '1') {
          this.processList.push({
            'processCode': 'CARDORG',
            'stageCode': 'AdaForm',
            'stageName': 'ADA Form',
            'stageDescription': ''
          });
        }
        if (this.applicationStatus?.status == 'DDE' && this.isSentbackApplication) {
          this.processList.splice(1, 0, {
            'processCode': 'CARDORG',
            'stageCode': 'PendencyInfo',
            'stageName': 'Return Reasons',
            'stageDescription': ''
          },)
        }
      }
    }
    else if (this.processCode == 'SUPPLCARDORG') {
      this.processList = [
        {
          'processCode': 'CARDORG',
          'stageCode': 'SupplApplicantInfo',
          'stageName': 'Suppl Applicant Details',
          'stageDescription': ''
        },
        {
          'processCode': 'SUPPLCARDORG',
          'stageCode': 'SupplCustomerDetails',
          'stageName': 'Supplementary Applicant Details',
          'stageDescription': ''
        },
        {
          'processCode': 'SUPPLCARDORG',
          'stageCode': 'SupplOccupationInfo',
          'stageName': 'Supplementary Employment Details',
          'stageDescription': ''
        },
        {
          'processCode': 'SUPPLCARDORG',
          'stageCode': 'documentinfo',
          'stageName': 'Supplementary Document Upload',
          'stageDescription': ''
        }
      ];
      if (this._adaFormConfig.payrollIdentifier === 1 || this._adaFormConfig.payrollIdentifier === '1') {
        this.processList.push({
          'processCode': 'SUPPLCARDORG',
          'stageCode': 'AdaForm',
          'stageName': 'ADA Form',
          'stageDescription': ''
        });
      }

      if (this.getApplicationMode() == 'RM') {
        let PrimaryApplicantInfo = {
          'processCode': 'SUPPLCARDORG',
          'stageCode': 'PrimaryApplicantInfo',
          'stageName': 'Primary Cardholder Address',
          'stageDescription': ''
        };
        this.processList.splice(1,0,PrimaryApplicantInfo);
      }
      if (this.applicationStatus?.status == 'DDE' && this.isSentbackApplication) {
        this.processList.splice(1,0,{
          'processCode': 'SUPPLCARDORG',
          'stageCode': 'PendencyInfo',
          'stageName': 'Return Reasons',
          'stageDescription': ''
        },)
      }
    }
  }
  getActiveStageIndex() {
    return this.activeStageIndex;
  }

  copyARN() {
    this._dataStore.shareInfo(this.arn, this.translate.instant('COMMON.copied'))
  }

  onCancel() {
    this.clearDraftProcessInfo();
    this._commonService.exitApplication();
  }

  getApplicationMode(): string {
    return this._commonService.getApplicationMode();
  }

  setBODTitle(title: string) {
    this._bodTitle = title;
  }
  getBODTitle(): string {
    return this._bodTitle || "Detail Data Entry";
  }

  setBODInfo(data: any) {
    this._bodInfoData = data;
  }
  getBodNumber(): number {
    return this._bodInfoData?.bodNumber;
  }

  saveTheStage() {
    /** Use getRawValue(): disabled controls (e.g. docType on category "D" rows) are omitted from .value, so documentType was missing and the merge below treated many rows as duplicates (undefined == undefined), corrupting docdtls. */
    const raw = this.formComponent.formGroup.getRawValue();
    console.log('save the stage', this.processCode, this.stageCode, this.processId, raw);
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/bpstagecontext/{processCode}/{stageCode}/{processId}');
    httpRequest.addPathParameter('processCode', this.processCode);
    httpRequest.addPathParameter('stageCode', this.stageCode);
    httpRequest.addPathParameter('processId', this.processId);
    httpRequest.setMethod('PUT');
    httpRequest.setServerContext(environment.commonPublisher);

    let formGroupValue = this.formComponent.removeNull(JSON.parse(JSON.stringify(raw)));
    if (formGroupValue.docdtls) {
      for (let i = 0; i < formGroupValue.docdtls.length; i++) {
        formGroupValue.docdtls[i].documents = [JSON.parse(JSON.stringify(formGroupValue.docdtls[i]))];
        for (var j = 0; j < formGroupValue.docdtls.length; j++) {
          const a = formGroupValue.docdtls[i]?.documentType;
          const b = formGroupValue.docdtls[j]?.documentType;
          if (
            i !== j &&
            a != null &&
            a !== '' &&
            a === b
          ) {
            formGroupValue.docdtls[i].documents.push(formGroupValue.docdtls[j]);
            formGroupValue.docdtls.splice(j, 1);
            j--;
          }
        }
      }
    }
    let context = formGroupValue;

    let bodyContent = {
      "bpstagecontext": {
        "contextData": JSON.stringify(context)
      }
    }

    httpRequest.setBody(bodyContent);

    return this._http.invokeRestApi(httpRequest).subscribe({
      next: (res) => {
        console.log('res: ', res);
        this._commonService.showToastr({
          message: "Saved as Draft!"
        })
      },
      error: (reason) => {
        console.log('reason: ', reason);
      }
    });
  }

  getStageContext() {
    return this._stageContext || null;
  }

  /**
   * Grid patch: processinfo `documentinfo` first, else processinstance / bpstagecontext
   * (nested `documents[]` flattened). Used by document-info and supplementary document screens.
   */
  getDocumentGridPatchPayload(): { docdtls: any[]; appRef?: string } | null {
    const pc = this.processCode;
    const procDoc = pc && this.processInfo?.processPayload?.[pc]?.documentinfo;
    if (procDoc?.docdtls?.length) {
      return {
        appRef: procDoc.appRef || this.processId,
        docdtls: JSON.parse(JSON.stringify(procDoc.docdtls)),
      };
    }
    const ctx = this.getStageContext();
    if (ctx == null) {
      return null;
    }
    if (Array.isArray(ctx)) {
      const docdtls = JSON.parse(JSON.stringify(ctx));
      this.normalizeDocumentfileinvWrappers(docdtls);
      return { appRef: this.processId, docdtls };
    }
    if (!ctx.docdtls?.length) {
      return null;
    }
    const needsFlatten = ctx.docdtls.some(
      (row: any) => Array.isArray(row?.documents) && row.documents.length > 0
    );
    if (needsFlatten) {
      const flat = this.flattenContextDataDocumentinfo(JSON.parse(JSON.stringify(ctx)));
      return {
        appRef: flat.appRef || ctx.appRef || this.processId,
        docdtls: flat.docdtls,
      };
    }
    const docdtls = JSON.parse(JSON.stringify(ctx.docdtls));
    this.normalizeDocumentfileinvWrappers(docdtls);
    return {
      appRef: ctx.appRef || this.processId,
      docdtls,
    };
  }

  /**
   * bpstagecontext / processinstance: parent rows may nest multiple `documents[]`.
   * Flatten to one grid row per entry; `prntDocType` from parent `documentType` when missing.
   */
  private flattenContextDataDocumentinfo(context: any): any {
    const flat: any[] = [];
    for (let i = 0; i < context.docdtls.length; i++) {
      const parent = context.docdtls[i];
      const prnt = parent.prntDocType || parent.documentType;
      const docs = parent.documents;
      if (docs?.length) {
        for (let j = 0; j < docs.length; j++) {
          const child = { ...docs[j] };
          delete child.documents;
          flat.push({ prntDocType: prnt, ...child });
        }
      } else {
        const row = { ...parent };
        delete row.documents;
        flat.push({ prntDocType: prnt, ...row });
      }
    }
    const out = { ...context, docdtls: flat };
    this.normalizeDocumentfileinvWrappers(out.docdtls);
    return out;
  }

  private normalizeDocumentfileinvWrappers(docdtls: any[]): void {
    docdtls?.forEach((doctype: any) => {
      if (!Array.isArray(doctype.documentfileinv)) {
        return;
      }
      const inner0 = doctype.documentfileinv[0];
      if (
        doctype.documentfileinv.length === 1 &&
        inner0 &&
        Array.isArray(inner0.docInvNum)
      ) {
        inner0.docInvNum?.forEach((inv: any) => {
          if (inv != null && inv.invNumber === undefined && inv.docInvNum !== undefined) {
            inv.invNumber = inv.docInvNum;
          }
        });
        return;
      }
      doctype.documentfileinv.forEach((file: any) => {
        if (file != null && file.invNumber === undefined && file.docInvNum !== undefined) {
          file.invNumber = file.docInvNum;
        }
      });
      doctype.documentfileinv = [{ docInvNum: doctype.documentfileinv }];
    });
  }

  /**
   * CENTRAL POWER: Logic to manage form stage accessibility.
   * Keeps controls ENABLED but restricts UI interaction.
   */
  public isStageEditable(stageCode: string): boolean {
    const editableTabs = ['documentinfo', 'AdaForm'];
    
    // 1. If status is 'AddlDocmt', strictly enforce the whitelist (Only Document/ADA)
    // if (this.applicationStatus?.status === 'AddlDocmt') {
    //   return editableTabs.includes(stageCode);
    // }

    // 2. If payrollIdentifier is '1', disable all tabs except documentinfo and AdaForm
    const isPayrollIdentifierValid = this._adaFormConfig?.payrollIdentifier === 1 || this._adaFormConfig?.payrollIdentifier === '1';
    if (isPayrollIdentifierValid) {
      return editableTabs.includes(stageCode);
    }

    // 3. For all other statuses (like 'DDE'), decide if everything should be editable 
    // or follow a different rule. 
    console.log(this.applicationStatus?.status, "Application hit _________________________")
    return (this.applicationStatus?.status === 'DDE' || !this.applicationStatus?.status);
  }
}

